import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Slide,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function Popup(props) {
  const {
    title,
    children,
    openPopup,
    setOpenPopup,
    maxWidth = "md",
    scroll = "paper",
  } = props;

  return (
    <Dialog
      open={openPopup}
      maxWidth={maxWidth}
      fullWidth
      TransitionComponent={Transition}
      onClose={() => setOpenPopup(false)}
      sx={{
        "& .MuiDialog-paper": {
          padding: 0,
          position: "absolute",
          top: { xs: 0, sm: 8 }, // responsive top spacing
        },
      }}
    >
      <DialogTitle
        sx={{
          paddingRight: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenPopup(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          p: { xs: 1, sm: 2 }, 
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
